import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg3DPathLength = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 71.955,
	height: 33.802,
	viewBox: "0 0 71.955 33.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_145",
		"data-name": "Group 145",
		transform: "translate(0)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_143",
			"data-name": "Group 143",
			opacity: 0,
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_284",
				"data-name": "Path 284",
				d: "M856.632,179.413H784.677v-33.8h71.955Zm-71.435-.52h70.915V146.131H785.2Z",
				transform: "translate(-784.677 -145.611)",
				fill: "#040505"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_144",
			"data-name": "Group 144",
			transform: "translate(8.813 1.976)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_285",
					"data-name": "Path 285",
					d: "M812.516,172.579a14.239,14.239,0,0,0-3.82.859c-.459.147-.893.286-1.148.343-.2.045-.444.085-.714.131-1.589.267-4.9.823-4.571,3.6a2.7,2.7,0,0,0,1.025,1.92c1.206.922,3.021.653,4.624.414a12.409,12.409,0,0,1,1.606-.176,4.647,4.647,0,0,1,1.333.268,8.392,8.392,0,0,0,2.56.438c2.23,0,4.568-1.133,4.726-3.3a3.563,3.563,0,0,0-.978-2.741A6.387,6.387,0,0,0,812.516,172.579Zm.895,5.714a6.354,6.354,0,0,1-1.965-.351,6.476,6.476,0,0,0-1.928-.355,13.6,13.6,0,0,0-1.912.2c-1.075.16-2.549.379-3.056-.009-.049-.037-.18-.137-.223-.511-.079-.671,1.083-1.007,2.85-1.3.313-.052.6-.1.825-.152.346-.077.8-.223,1.327-.391a13.334,13.334,0,0,1,3.187-.76,4.436,4.436,0,0,1,3.12,1.088,1.493,1.493,0,0,1,.427,1.175C816,177.768,814.638,178.293,813.411,178.293Z",
					transform: "translate(-801.926 -160.539)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_286",
					"data-name": "Path 286",
					d: "M889.873,174.33a6.387,6.387,0,0,0-4.643-1.751,14.235,14.235,0,0,0-3.82.859c-.459.147-.893.286-1.148.343-.2.045-.444.085-.714.131-1.589.267-4.895.823-4.571,3.6h0a2.7,2.7,0,0,0,1.024,1.92c1.206.922,3.022.653,4.625.414a12.415,12.415,0,0,1,1.606-.176,4.657,4.657,0,0,1,1.334.268,8.387,8.387,0,0,0,2.559.438c2.229,0,4.568-1.133,4.726-3.3A3.564,3.564,0,0,0,889.873,174.33Zm-3.748,3.963a6.359,6.359,0,0,1-1.966-.351,6.471,6.471,0,0,0-1.928-.355,13.594,13.594,0,0,0-1.912.2c-1.075.16-2.549.379-3.055-.009-.05-.037-.179-.137-.224-.51-.078-.671,1.083-1.007,2.851-1.3.313-.052.6-.1.825-.152.346-.077.8-.223,1.327-.391a13.333,13.333,0,0,1,3.187-.76,4.437,4.437,0,0,1,3.12,1.088,1.489,1.489,0,0,1,.426,1.175C888.716,177.768,887.353,178.293,886.126,178.293Z",
					transform: "translate(-836.85 -160.539)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_287",
					"data-name": "Path 287",
					d: "M849.511,192.376a8.4,8.4,0,0,0-2.559.438,4.654,4.654,0,0,1-1.334.268,12.319,12.319,0,0,1-1.606-.176c-1.6-.238-3.419-.509-4.624.414a2.705,2.705,0,0,0-1.025,1.92c-.325,2.773,2.982,3.329,4.57,3.6.271.046.517.086.715.131.256.057.69.2,1.148.343a14.217,14.217,0,0,0,3.82.86,6.387,6.387,0,0,0,4.643-1.752,3.559,3.559,0,0,0,.978-2.741C854.079,193.51,851.74,192.376,849.511,192.376ZM851.737,197a4.442,4.442,0,0,1-3.121,1.089,13.343,13.343,0,0,1-3.185-.76c-.527-.169-.982-.314-1.328-.392-.229-.051-.512-.1-.825-.152-1.767-.3-2.928-.633-2.85-1.3.044-.374.174-.474.224-.511.506-.389,1.979-.169,3.055-.009a13.589,13.589,0,0,0,1.911.2,6.468,6.468,0,0,0,1.927-.354,6.359,6.359,0,0,1,1.966-.352c1.228,0,2.591.525,2.652,1.372A1.491,1.491,0,0,1,851.737,197Z",
					transform: "translate(-819.264 -170.048)",
					fill: "#040505",
					opacity: .3
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_288",
					"data-name": "Path 288",
					d: "M802.983,162.7a1.039,1.039,0,0,0,.328.116,1,1,0,0,0,.177.016,1.039,1.039,0,0,0,.217-.023l3.829-.814a1.039,1.039,0,1,0-.432-2.033l-1.141.243a18.673,18.673,0,0,1,31.842.423l-1.216-.258a1.039,1.039,0,0,0-.432,2.033l3.829.814a1.008,1.008,0,0,0,.217.023,1.041,1.041,0,0,0,1.016-.824l.814-3.829a1.039,1.039,0,0,0-2.033-.432l-.328,1.545a20.749,20.749,0,0,0-35.632-.331l-.345-1.621a1.039,1.039,0,0,0-2.033.432l.814,3.829A1.035,1.035,0,0,0,802.983,162.7Z",
					transform: "translate(-801.635 -149.413)",
					fill: "#040505"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(Svg3DPathLength);
export { ForwardRef as ReactComponent };
